// Domain: Transfers
// Uses the shared low-level helpers from core/request (apiGet/apiPost) so
// CSRF/session cookies and error normalization stay consistent across the app.

import { apiGet, apiPost } from "../core/request";

/**
 * List transfers (parity with Blade index pagination: 15/page, 'transfers_page' cursor)
 * Accepts search, status, and transfers_page to match your Laravel paginator param name.
 * GET /xapi/transfers -> JSON paginator (data, current_page, last_page, links, etc.)
 */
export async function apiTransfersIndex(params: {
  search?: string;
  status?: string;
  transfers_page?: number | string;
}) {
  const query = new URLSearchParams();
  if (params?.search) query.set("search", params.search);
  if (params?.status) query.set("status", params.status);
  if (params?.transfers_page !== undefined) {
    query.set("transfers_page", String(params.transfers_page));
  }
  return apiGet(`/xapi/transfers?${query.toString()}`);
}

/**
 * Show a single transfer with relations used by the Blade "details" page:
 * recipient, pofDocument, sowDocument (if present).
 */
export async function apiTransferShow(id: number | string) {
  return apiGet(`/xapi/transfers/${id}`);
}

/**
 * Accounts used to resolve the source account by currency (SPA finds it and sends account_id).
 */
export async function apiAccountsIndex() {
  return apiGet(`/xapi/accounts`);
}

/**
 * Create transfer — mirrors App\Http\Controllers\Xapi\TransferWriteController@store
 * Required: account_id, recipient_id, amount, currency
 * Optional: transfer_type (sepa|swift), purpose_of_payment, reference_number
 * Returns: { id, status, type, currency, amount, compliance:{require_pof,require_sow}, next }
 */
export async function apiTransferCreate(payload: {
  account_id: number;
  recipient_id: number;
  amount: number | string;
  currency: string;
  transfer_type?: "sepa" | "swift" | "SEPA" | "SWIFT";
  purpose_of_payment?: string;
  reference_number?: string;
}) {
  return apiPost(`/xapi/transfers`, payload);
}
